import Repository from "./Repository";

const CREATE_TRANSACTION = "create";
const UPDATE_TRANSACTION = "update";

export default {
  create_transaction(payload) {
    return Repository.post(transformRoute(CREATE_TRANSACTION), payload);
  },
  update_transaction(payload) {
    return Repository.post(transformRoute(UPDATE_TRANSACTION), payload);
  },
};

const transformRoute = (route) => {
  return `transaction/${route}`;
};
